import { MaterialReactTable, MRT_GlobalFilterTextField, useMaterialReactTable } from 'material-react-table';
import { Box, lighten } from '@mui/material';

const TableBasicAlunosDesconto = ({ data }) => {
  const columns = [
    {
      accessorKey: 'quantity',
      header: 'Quantidade de Alunos',
      sortDescFirst: false,
      enableMultiSort: false,
      size: 3,
      Cell: ({ renderedCellValue }) => {
        return <div style={{ textAlign: 'center' }}>{renderedCellValue}</div>;
      },
    },

    {
      accessorKey: 'value',
      header: '% de Desconto',
      sortDescFirst: false,
      enableMultiSort: false,
      Cell: ({ renderedCellValue }) => {
        return (
          <div
            style={{
              width: `${renderedCellValue}%`,
              background: '#E04A4C',
              color: '#fff',
              padding: '8px',
              textAlign: 'end',
              paddingRight: '5px',
            }}
          >
            {<Box sx={{ marginRight: '5px' }}>{renderedCellValue}</Box>}
          </div>
        );
      },
    },
  ];

  const tableBasic = useMaterialReactTable({
    columns,
    data,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enableBottomToolbar: false,
    enableSorting: false,
    initialState: {
      showGlobalFilter: true,
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: ({ column }) => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
        padding: 0,
      },
    }),
    renderTopToolbar: ({ table }) => (
      <Box
        sx={(theme) => ({
          backgroundColor: lighten(theme.palette.background.default, 0.05),
          display: 'none',
          gap: '0.5rem',
          p: '8px',
          justifyContent: 'space-between',
        })}
      >
        <Box sx={{ borderRadius: '20px' }}>
          <MRT_GlobalFilterTextField table={table} />
        </Box>
      </Box>
    ),
  });

  return (
    <Box
      sx={{
        boxShadow: '0px 8px 10px 0px #00000040',
      }}
    >
      <MaterialReactTable table={tableBasic} />
    </Box>
  );
};

export default TableBasicAlunosDesconto;
